import { motion } from "framer-motion";
import { Apple } from "lucide-react";
import { APP_STORE_URL } from "@/constants/site";

const AppStoreButton = ({ variant = "light", size = "lg", testId }) => {
  const isLight = variant === "light";
  const base = isLight
    ? "bg-white text-black hover:shadow-[0_0_50px_rgba(255,255,255,0.25)]"
    : "bg-crimson text-white hover:bg-crimson-hover hover:shadow-[0_0_60px_rgba(229,9,20,0.5)]";
  const pad = size === "lg" ? "px-7 py-3.5" : "px-4 py-2";
  const iconSize = size === "lg" ? 30 : 22;

  return (
    <motion.a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      whileHover={{ scale: 1.03 }}
      whileTap={{ scale: 0.97 }}
      transition={{ type: "spring", stiffness: 400, damping: 20 }}
      className={`inline-flex items-center gap-3 rounded-full font-heading transition-shadow duration-300 ${base} ${pad}`}
    >
      <Apple size={iconSize} strokeWidth={2.2} fill="currentColor" />
      <span className="flex flex-col items-start leading-none">
        <span className={`${size === "lg" ? "text-[11px]" : "text-[9px]"} font-body font-medium opacity-70 tracking-wide`}>
          Download on the
        </span>
        <span className={`${size === "lg" ? "text-xl" : "text-sm"} font-bold tracking-tight mt-0.5`}>
          App Store
        </span>
      </span>
    </motion.a>
  );
};

export default AppStoreButton;
